export const SET_BREADCRUMB_ROUTES = 'SET_BREADCRUMB_ROUTES'
export const GET_APILIST = 'GET_APILIST'
export const SET_APILIST = 'SET_APILIST'
export const GET_API_DATA = 'GET_API_DATA'
export const SET_API_DATA = 'SET_API_DATA'

export const GET_LISTVIEW = 'GET_LISTVIEW'
export const SET_LISTVIEW = 'SET_LISTVIEW'
export const ADD_LISTVIEW = 'ADD_LISTVIEW'
export const UPDATE_LISTVIEW = 'UPDATE_LISTVIEW'
export const DELETE_LISTVIEW = 'DELETE_LISTVIEW'
export const GET_LISTVIEW_DETAIL = 'GET_LISTVIEW_DETAIL'
export const SET_LISTVIEW_DETAIL = 'SET_LISTVIEW_DETAIL'

export const GET_FORMVIEW = 'GET_FORMVIEW'
export const SET_FORMVIEW = 'SET_FORMVIEW'
export const ADD_FORMVIEW = 'ADD_FORMVIEW'
export const COPY_FORMVIEW = 'COPY_FORMVIEW'
export const UPDATE_FORMVIEW = 'UPDATE_FORMVIEW'
export const DELETE_FORMVIEW = 'DELETE_FORMVIEW'
export const GET_ENGINE_LIST = 'GET_ENGINE_LIST'
export const SET_ENGINE_LIST = 'SET_ENGINE_LIST'
export const GET_FORMVIEW_DETAIL = 'GET_FORMVIEW_DETAIL'
export const SET_FORMVIEW_DETAIL = 'SET_FORMVIEW_DETAIL'
export const GET_FORM_COMPONENTS = 'GET_FORM_COMPONENTS'
